/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import MessagingChannelSetup from 'cio/components/setup-guide/channels/messaging/setup';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';

export default class SetupGuideMessagingPushComponent extends MessagingChannelSetup {
  @service router!: RouterService;
  channel = MessagingChannelType.Push;
  showSuccessAlert = false;

  @action
  goToIosSetup() {
    this.router.transitionTo('actions.push.ios');
  }

  @action
  goToAndroidSetup() {
    this.router.transitionTo('actions.push.android');
  }
}
